import MinusButton from "components/MinusButton";
import PlusButton from "components/PlusButton";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import { useWatch } from "react-hook-form";
import { SecurityAddState } from "../atoms/atoms";
import { useRecoilState } from "recoil";
import { TimeRangeInput } from "components/TimeInputsSecurity";

export const CardReaderGroup = ({
  groupInfoFields,
  appendGroupInfo,
  removeGroupInfo,
  FormMethods,
}) => {
  const { register, control, getValues, setValue, formState, watch } =
    FormMethods;

  const watchedGroupInfo = useWatch({ control, name: "groupInfos" });
  const [isAdd] = useRecoilState(SecurityAddState);

  return (
    <>
      <div className="space-y-2">
        {groupInfoFields.map((field, index) => {
          const groupInfoName = `groupInfos.${index}`;
          const groupData = watch(groupInfoName);

          const daysConfig = [
            {
              day: "monday",
              hours: "monday_hours",
              start: "mondayStartTime",
              end: "mondayEndTime",
            },
            {
              day: "tuesday",
              hours: "tuesday_hours",
              start: "tuesdayStartTime",
              end: "tuesdayEndTime",
            },
            {
              day: "wednesday",
              hours: "wednesday_hours",
              start: "wednesdayStartTime",
              end: "wednesdayEndTime",
            },
            {
              day: "thursday",
              hours: "thursday_hours",
              start: "thursdayStartTime",
              end: "thursdayEndTime",
            },
            {
              day: "friday",
              hours: "friday_hours",
              start: "fridayStartTime",
              end: "fridayEndTime",
            },
            {
              day: "saturday",
              hours: "saturday_hours",
              start: "saturdayStartTime",
              end: "saturdayEndTime",
            },
            {
              day: "sunday",
              hours: "sunday_hours",
              start: "sundayStartTime",
              end: "sundayEndTime",
            },
          ];

          if (isAdd) {
            daysConfig.forEach(({ hours, start, end }) => {
              const dayHours = groupData?.[hours] ?? "";
              const currentStart = groupData?.[start];
              const currentEnd = groupData?.[end];

              if (dayHours && !currentStart && !currentEnd) {
                const [startTime, endTime] = dayHours.split("-");
                if (startTime) {
                  setValue(`${groupInfoName}.${start}`, startTime.trim(), {
                    shouldDirty: true,
                  });
                }
                if (endTime) {
                  setValue(`${groupInfoName}.${end}`, endTime.trim(), {
                    shouldDirty: true,
                  });
                }
              }
            });
          }

          const doorPath = `${groupInfoName}.doors`;
          const doors = getValues(doorPath) || [];
          const handleAddDoor = () => {
            const newDoors = [...doors, ""];
            setValue(doorPath, newDoors);
          };

          const handleRemoveDoor = (doorIndex: number) => {
            const newDoors = doors.filter((_, i) => i !== doorIndex);
            setValue(doorPath, newDoors);
          };

          return (
            <>
              <section
                key={field.id}
                className="grid grid-cols-2 gap-x-4 gap-y-4  relative py-6 px-4 border-b bg-white box-shadow rounded-lg"
              >
                <div className="grid grid-cols-[auto,1fr] space-x-2 ">
                  <div className="flex items-center gap-2 w-5">
                    {index !== 0 && (
                      <MinusButton
                        type="button"
                        onClick={() => removeGroupInfo(index)}
                        aria-label={`Remove group ${index + 1}`}
                      />
                    )}

                    {index === 0 && (
                      <PlusButton
                        type="button"
                        onClick={() => {
                          appendGroupInfo({
                            daysOftheWeek: "",
                            daysOftheWeekArr: [],
                            groupTitle: "",
                            staffEmployee: "",
                            days: "",
                            startDate: "",
                            endDate: "",

                            mondayStartTime: "",
                            mondayEndTime: "",
                            tuesdayStartTime: "",
                            tuesdayEndTime: "",
                            wednesdayStartTime: "",
                            wednesdayEndTime: "",
                            thursdayStartTime: "",
                            thursdayEndTime: "",
                            fridayStartTime: "",
                            fridayEndTime: "",
                            saturdayStartTime: "",
                            saturdayEndTime: "",
                            sundayStartTime: "",
                            sundayEndTime: "",
                            doors: [""],
                          });
                        }}
                        className={
                          groupInfoFields.length >= 10
                            ? "opacity-50 cursor-not-allowed pointer-events-none"
                            : ""
                        }
                        aria-label="Add new group"
                      />
                    )}
                  </div>
                  <div className="text-blue-800 font-semibold text-sm">
                    Group Information {index + 1}
                  </div>
                </div>
                <div className=""></div>
                <div className="space-y-3">
                  <TextInputLabelHookForm
                    className={
                      formState.errors?.groupInfos?.[index]?.groupTitle
                        ? "border border-red-500 w-full col-span-2"
                        : "border border-slate-200 w-full col-span-2"
                    }
                    name={field.name}
                    label="Group Title"
                    type="text"
                    maxLength={50}
                    register={register(`${groupInfoName}.groupTitle` as const, {
                      validate: (value) => {
                        if (!value || value.trim() === "") {
                          return "Group title is required";
                        }
                        return true;
                      },
                    })}
                    required={true}
                    onChange={(e) => {
                      setValue(`${groupInfoName}.groupTitle`, e.target?.value, {
                        shouldDirty: true,
                      });
                    }}
                  />
                </div>
                <div className="">
                  <TextInputLabelHookForm
                    name={field.name}
                    label="Staff Group"
                    type="text"
                    maxLength={200}
                    register={register(`${groupInfoName}.staffGroup`, {})}
                    onChange={(e) => {
                      setValue(`${groupInfoName}.staffGroup`, e.target.value, {
                        shouldDirty: true, //
                      });
                    }}
                  />
                </div>

                <div className="text-blue-800 font-semibold text-sm flex">
                  <label className="w-[50%] ">Hours</label>
                  <div className=" w-full flex gap-x-4 ">
                    <label className=" w-full">Start Time</label>
                    <label className="w-full">End Time</label>
                  </div>
                </div>
                <div className="text-blue-800 font-semibold text-sm flex">
                  <label className="w-[50%] "></label>
                  <div className=" w-full flex gap-x-4 ">
                    <label className=" w-full">Start Time</label>
                    <label className="w-full">End Time</label>
                  </div>
                </div>

                {/* //Hours */}
                <div className="space-y-3">
                  {/* Mon */}
                  <TimeRangeInput
                    day="monday"
                    groupInfoName={`groupInfos.${index}`}
                    index={index}
                    isAdd={isAdd}
                    FormMethods={FormMethods}
                  />
                  {/* Tue */}
                  <TimeRangeInput
                    day="tuesday"
                    groupInfoName={`groupInfos.${index}`}
                    index={index}
                    isAdd={isAdd}
                    FormMethods={FormMethods}
                  />
                  {/* Wed */}
                  <TimeRangeInput
                    day="wednesday"
                    groupInfoName={`groupInfos.${index}`}
                    index={index}
                    isAdd={isAdd}
                    FormMethods={FormMethods}
                  />
                  {/* Thu */}
                  <TimeRangeInput
                    day="thursday"
                    groupInfoName={`groupInfos.${index}`}
                    index={index}
                    isAdd={isAdd}
                    FormMethods={FormMethods}
                  />
                  {/* Fri */}
                  <TimeRangeInput
                    day="friday"
                    groupInfoName={`groupInfos.${index}`}
                    index={index}
                    isAdd={isAdd}
                    FormMethods={FormMethods}
                  />
                </div>

                {/* Hours right/ */}
                <div className="space-y-3">
                  {/* Sat */}
                  <TimeRangeInput
                    day="saturday"
                    groupInfoName={`groupInfos.${index}`}
                    index={index}
                    isAdd={isAdd}
                    FormMethods={FormMethods}
                  />

                  {/* Sun */}
                  <TimeRangeInput
                    day="sunday"
                    groupInfoName={`groupInfos.${index}`}
                    index={index}
                    isAdd={isAdd}
                    FormMethods={FormMethods}
                  />
                </div>

                <div className="text-blue-800 font-semibold text-sm">
                  Door Access
                </div>
                <div></div>

                <div className="col-span-2 grid grid-cols-2 gap-x-4 gap-y-2">
                  {/* Left column */}
                  <div className="space-y-3 ">
                    {watchedGroupInfo?.[index]?.doors
                      ?.slice(0, 5)
                      .map((_, doorIndex) => (
                        <div
                          key={doorIndex}
                          className="grid grid-cols-[auto,1fr] gap-4"
                        >
                          <div className="flex items-center  ">
                            {doorIndex !== 0 && (
                              <MinusButton
                                className="mr-5"
                                type="button"
                                onClick={() => handleRemoveDoor(doorIndex)}
                                aria-label={`Remove door ${doorIndex + 1}`}
                              />
                            )}

                            {doorIndex === 0 && (
                              <PlusButton
                                type="button"
                                onClick={handleAddDoor}
                                aria-label="Add new door"
                                className={
                                  doors.length >= 10
                                    ? "opacity-50 cursor-not-allowed pointer-events-none"
                                    : ""
                                }
                              />
                            )}
                          </div>
                          <div className="flex items-center ">
                            <label className="text-xs w-[38%]">{`Door ${
                              doorIndex + 1
                            }`}</label>
                            <TextInputLabelHookForm
                              className="col-span-3 border"
                              type="text"
                              maxLength={200}
                              register={register(
                                `${doorPath}.${doorIndex}` as const
                                // {
                                //   required: `Door ${doorIndex + 1} is required`,
                                // }
                              )}
                              onChange={() => {}}
                            />
                          </div>

                          {formState.errors?.groupInfos?.[index]?.doors?.[
                            doorIndex
                          ] && (
                            <span className="text-red-500 text-sm mt-1 col-span-2">
                              {
                                formState.errors.groupInfos[index].doors[
                                  doorIndex
                                ].message
                              }
                            </span>
                          )}
                        </div>
                      ))}
                  </div>

                  {/* Right col */}
                  <div className="space-y-3">
                    {watchedGroupInfo?.[index]?.doors?.slice(5).map((_, i) => {
                      const doorIndex = i + 5;
                      return (
                        <div
                          key={doorIndex}
                          className="grid grid-cols-[auto,1fr] gap-4"
                        >
                          <div className="flex items-center pr-4 ">
                            <MinusButton
                              type="button"
                              onClick={() => handleRemoveDoor(doorIndex)}
                              aria-label={`Remove door ${doorIndex + 1}`}
                            />
                          </div>

                          <div className="flex items-center ">
                            <label className="text-xs w-[39%]">{`Door ${
                              doorIndex + 1
                            }`}</label>

                            <TextInputLabelHookForm
                              className="col-span-3 border"
                              type="text"
                              maxLength={200}
                              register={register(
                                `${doorPath}.${doorIndex}` as const
                                // {
                                //   required: `Door ${doorIndex + 1} is required`,
                                // }
                              )}
                              onChange={() => {}}
                            />
                          </div>

                          {formState.errors?.groupInfos?.[index]?.doors?.[
                            doorIndex
                          ] && (
                            <span className="text-red-500 text-sm mt-1 col-span-2">
                              {
                                formState.errors.groupInfos[index].doors[
                                  doorIndex
                                ].message
                              }
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </section>
            </>
          );
        })}
      </div>
    </>
  );
};
